import { get } from 'lodash';
import * as actionTypes from '../../constants/actionTypes';
import DBTypes from '../../../mocks/DBTypes';

export const loadDBDataTypes = (connectionType) => (dispatch, getState) => {
  if (!get(getState().dbDataTypes, `${connectionType}.lastUpdated`)) {
    return dispatch({
      type: actionTypes.GET_DB_DATA_TYPES_SUCCESS,
      data: DBTypes[connectionType],
      connectionType,
      receivedAt: Date.now(),
    });
  }
};
